// components/layout/RouteSuspense.tsx — Suspense wrapper for lazy route loading

import { Suspense, type ReactNode } from 'react';
import styles from './RouteSuspense.module.css';

interface RouteSuspenseProps {
  children: ReactNode;
}

export function RouteSuspense({ children }: RouteSuspenseProps) {
  return (
    <Suspense fallback={<RouteLoader />}>
      {children}
    </Suspense>
  );
}

function RouteLoader() {
  return (
    <div className={styles.loader} role="status" aria-label="Loading page">
      <div className={styles.spinner} />
    </div>
  );
}
